import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Automox extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path
          d="M21.7,19.8L13.9,5.6l-5.3,8.8h-2l7.4-12.3l8.8,15.6L21.7,19.8z M2.9,20.4l-1.2-1.9h16l-2.2-4l-2.6-4.9l1-1.7
	l6.9,12.6L2.9,20.4z M12.2,10.6l2,3.8l-4.3,0L12.2,10.6z M10.7,1.6h2.2L4.6,15.5l4.6,0l5.6,0l1,1.8H1.6L10.7,1.6z M14.6,1l-0.3-0.6
	h-4.1L0,17.9l2.2,3.6H22l2-3.8L14.6,1z"
        />
      </svg>
    );
  }
}

export default Automox;
